import React, { useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import { Box } from '@mui/material';

const WorkerCameraScanner = forwardRef((props, ref) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    useEffect(() => {
        let currentStream = null;
        const startCamera = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: { ideal: "user" }, width: 400, height: 400 },
                    audio: false
                });
                currentStream = stream;
                if (videoRef.current) videoRef.current.srcObject = stream;
            } catch (err) {
                console.error("Błąd kamery:", err);
            }
        };
        startCamera();
        return () => {
            if (currentStream) currentStream.getTracks().forEach(track => track.stop());
        };
    }, []);

    useImperativeHandle(ref, () => ({
        async capture() {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            if (!video || !canvas || video.readyState !== 4) return null;
            canvas.width = 400;
            canvas.height = 400;
            const ctx = canvas.getContext('2d');
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
            ctx.drawImage(video, 0, 0, 400, 400);
            return new Promise(resolve => canvas.toBlob(b => resolve(b), 'image/jpeg', 0.4));
        }
    }));

    return (
        <Box sx={{ 
            width: '100px', // Mniejsze oczko
            height: '100px', 
            mx: 'auto', 
            mb: 2, 
            borderRadius: '50%',
            border: '2px solid #ccc',
            overflow: 'hidden',
            bgcolor: '#000',
            opacity: 0.8
        }}>
            <video ref={videoRef} autoPlay playsInline muted style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)' }} />
            <canvas ref={canvasRef} style={{ display: 'none' }} />
        </Box>
    );
});

export default WorkerCameraScanner;